var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualityhd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(-242 -1894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    transform: "translate(242 1894)",
    fill: "none",
    stroke: "#999",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(255.5 1907.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M21.8,18.5a3.247,3.247,0,0,1-1.65,2.838V35h-3.3V21.338A3.267,3.267,0,0,1,15.2,18.5a3.3,3.3,0,0,1,6.6,0ZM18.5,8.6a9.88,9.88,0,0,0-6.7,17.16l2.343-2.343A6.529,6.529,0,0,1,11.9,18.5a6.6,6.6,0,0,1,13.2,0,6.529,6.529,0,0,1-2.244,4.917L25.2,25.76A9.88,9.88,0,0,0,18.5,8.6Zm0-6.6A16.491,16.491,0,0,0,7.132,30.446L9.475,28.1a13.2,13.2,0,1,1,18.051,0l2.343,2.343A16.491,16.491,0,0,0,18.5,2Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityhd);
export default __webpack_public_path__ + "static/media/qualityhd.6bf92d779e253babc2db1f9101b308b1.svg";
export { ForwardRef as ReactComponent };